@if (recipefirstLayout) {
  <div class="flex rounded-lg flex-col" [ngClass]="{'bg-white': condensed}">
    <div class="flex flex-row items-center gap-[0.625rem]" [ngClass]="{'lg:gap-[1.5rem]': useSummaryPageStyle}">
      <div class="w-full max-w-[4.375rem]" [ngClass]="useSummaryPageStyle ? 'md:max-w-[7rem]' : ''">
        <app-image [alt]="_product?.name" [src]="_product?.websitethumbimageurl" class="rounded-[1rem] h-[3.625rem] md:h-[4.875rem] object-cover" [ngClass]="useSummaryPageStyle ? 'md:block hidden' : 'hidden'"></app-image>
        <app-image [alt]="_product?.name" [src]="_product?.websitethumbimageurl" class="rounded-[1rem] h-[4.375rem] object-cover" [ngClass]="useSummaryPageStyle ? 'md:hidden' : ''"></app-image>
      </div>
      <div class="flex flex-grow flex-col" [ngClass]="useSummaryPageStyle ? 'md:flex-row' : 'gap-[0.2rem]'">
        <div>
          <div [ngClass]="useSummaryPageStyle ? 'font-[700] text-e-dark-green md:text-[1.25rem] mb-[0.125rem]' : 'font-[600] text-black'" class="text-[0.875rem] leading-[120%]">
            @if (_product) {
              {{_product?.title || _product?.name}}
            } @else {
              {{_orderline?.description}}
            }
          </div>
          <div class="flex text-[0.75rem] gap-[0.25rem]" [ngClass]="useSummaryPageStyle ? 'md:text-[1rem]' : ''">
            <span>{{_product?.shopquantity}} {{'unit.' + _product?.shopunit | translate }}</span>
            @if (_orderline) {
              <pricetag [calculatedPrice]="_orderline['calculatedPrice']" [couponcodeItem]="(_orderline && _orderline['couponcodeitem'])" [compensationItem]="_orderline &&_orderline['compensationitem']" [hideSmallTag]="hidePriceSmallTag" [ngClass]="{'md:hidden': useSummaryPageStyle}"></pricetag>
            }
          </div>
        </div>
        <div class="flex-grow flex gap-[0.3rem] items-center" [ngClass]="useSummaryPageStyle ? 'md:gap-[0.625rem] lg:gap-[1.5rem] md:justify-end' : ''">
          @if (removable) {
            <div class="order-1 md:order-3 mb-0 hidden" [ngClass]="useSummaryPageStyle ? 'md:block' : ''">
              <button class="block leading-[1] md:text-[1.75rem] text-[1rem] md:w-[1.75rem] w-[1rem]" (click)="removeProductline()">
                <i class="bi bi-x-circle"></i>
              </button>
            </div>
            <button class="leading-[1]" (click)="removeProductline()" [ngClass]="useSummaryPageStyle ? 'md:hidden block' : ''">
              <img src="./assets/images/icons/delete-recipefirst.svg" height="20px" width="20px" alt="delete" />
            </button>
          }
          @if (useSummaryPageStyle && _orderline) {
            <div class="text-e-dark-green md:text-[1.25rem] text-[0.875rem] order-2 md:block hidden">
              <pricetag [calculatedPrice]="_orderline['calculatedPrice']" [couponcodeItem]="(_orderline && _orderline['couponcodeitem'])" [compensationItem]="_orderline &&_orderline['compensationitem']" [hideSmallTag]="hidePriceSmallTag"></pricetag>
            </div>
          }
          <div class="flex" [ngClass]="{'md:order-1 order-3': useSummaryPageStyle}">
            <app-quantityselection-compact class="block" small [editable]="qtyeditable" [quantity]="quantity.value" (quantityChange)="setQuantity($event)" [contrastColorscheme]="colorscheme"></app-quantityselection-compact>
          </div>
          @if (repeatableeditable) {
            <app-toggle class="mt-6 inline-block" [formControl]="repeatable">{{'subscription.product_weekly' | translate}}</app-toggle>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="flex rounded-lg flex-col mt-5" [ngClass]="{'bg-white': condensed}">
    <div class="flex rounded-lg" [ngClass]="condensed ? 'flex-col bg-white' : 'flex-row'">
      <div [ngClass]="condensed ? 'w-full' : 'w-1/3 mr-2.5 max-w-[125px]'">
        <app-image [alt]="_product?.name" [src]="_product?.websitethumbimageurl" class="rounded-md w-full"
          [ngClass]="{'grayscale': calculatedPrice?.priceincvat === 0 && showPrice && (_orderline && !_orderline['couponcodeitem'] && !_orderline['compensationitem'] ) || (!deliverable && qtyeditable && showPrice) }">
        </app-image>
      </div>

      <div [ngClass]="condensed ? 'flex-col flex px-2.5 py-[15px] basis-[130px] shrink-0': 'flex-col flex-1'">
        <div class="flex flex-col justify-between mr-2.5">
          <small>
            <strong>
              @if (_product) {
                {{_product?.title || _product?.name}}
              } @else {
                {{_orderline?.description}}
              }
            </strong>
          </small>
          <small>{{_product?.shopquantity}} {{'unit.' + _product?.shopunit | translate }}</small>
        </div>

        <div class="flex flex-row flex-wrap justify-between mt-[15px] items-end">
          <div class="w-2/3 max-w-[175px]">
            <div>
              <app-quantityselection class="block" small [editable]="qtyeditable" [quantity]="quantity.value" (quantityChange)="setQuantity($event)"
              [contrastColorscheme]="colorscheme"></app-quantityselection>
            </div>
            @if (repeatableeditable) {
              <app-toggle class="mt-6 inline-block" [formControl]="repeatable">{{'subscription.product_weekly' | translate}}</app-toggle>
            }
          </div>

          @if (showPrice) {
            <div class="flex flex-wrap justify-end my-auto">
              @if (_orderline) {
                <pricetag [ngClass]="{'offset-7 mt-2': !qtyeditable && !repeatableeditable}" [calculatedPrice]="_orderline['calculatedPrice']"
                [couponcodeItem]="(_orderline && _orderline['couponcodeitem'])" [compensationItem]="_orderline &&_orderline['compensationitem']" [hideSmallTag]="hidePriceSmallTag"></pricetag>
              }
              @if (_productSelection) {
                <pricetag [ngClass]="{'offset-7 mt-2': !qtyeditable && !repeatableeditable}" [calculatedPrice]="_productSelection['calculatedPrice']"
                [couponcodeItem]="(_productSelection && _productSelection['couponcodeitem'])" [compensationItem]="_productSelection &&_productSelection['compensationitem']" [hideSmallTag]="hidePriceSmallTag"></pricetag>
              }
              @if (_repeatableProduct) {
                <pricetag [ngClass]="{'offset-7 mt-2': !qtyeditable && !repeatableeditable}" [calculatedPrice]="_repeatableProduct['calculatedPrice']"
                  [couponcodeItem]="(_repeatableProduct && _repeatableProduct['couponcodeitem'])" [compensationItem]="_repeatableProduct &&_repeatableProduct['compensationitem']" [hideSmallTag]="hidePriceSmallTag">
                </pricetag>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
@if(!deliverable && qtyeditable && showPrice){
  <small class="text-xs italic text-e-orange">{{'product.not_deliverable_anymore' |translate}}</small>
}
